export const exportCountries = [
  { key: 'spain', x: 14, y: 27, side: 'left' },
  { key: 'austria', x: 20.5, y: 20, side: 'left' },
  { key: 'dubai', x: 25, y: 27, side: 'left' },
  { key: 'ghana', x: 12.5, y: 46, side: 'left' },
  { key: 'russia', x: 43, y: 17, side: 'right' },
  { key: 'canada', x: 77, y: 14, side: 'right' },
  { key: 'usa', x: 76, y: 38, side: 'right' },
  { key: 'china', x: 51, y: 36, side: 'right' },
  { key: 'hongkong', x: 52.5, y: 41, side: 'right' },
  { key: 'philippines', x: 58.5, y: 45, side: 'right' },
  { key: 'malaysia', x: 46.5, y: 52, side: 'left' },
  { key: 'singapore', x: 48.5, y: 59, side: 'left' },
  { key: 'indonesia', x: 49.5, y: 63, side: 'right' },
  { key: 'australia', x: 55.5, y: 65, side: 'right' },
  { key: 'solomon', x: 63.5, y: 56, side: 'right' },
];

export const topMarkets = [
  { icon: 'ri-map-pin-line' },
  { icon: 'ri-map-pin-line' },
  { icon: 'ri-map-pin-line' },
  { icon: 'ri-map-pin-line' },
  { icon: 'ri-map-pin-line' },
  { icon: 'ri-map-pin-line' },
  { icon: 'ri-map-pin-line' },
  { icon: 'ri-map-pin-line' },
];

export const logisticsSteps = [
  { icon: 'ri-plant-line' },
  { icon: 'ri-shield-check-line' },
  { icon: 'ri-archive-2-line' },
  { icon: 'ri-ship-2-line' },
  { icon: 'ri-map-pin-2-line' },
];

export const complianceItems = [
  { icon: 'ri-shield-star-line' },
  { icon: 'ri-file-list-3-line' },
  { icon: 'ri-global-line' },
  { icon: 'ri-hand-heart-line' },
];